class CacheService {
  static relationsToUpdate = [];

  static setKey(cache, key, data) {
    cache.set(key, data);
  }

  static setRelationsToUpdate = newRelationsToUpdate => {
    CacheService.relationsToUpdate = newRelationsToUpdate;
  };

  static getUrlFromConfig(config) {
    return typeof config === 'string' ? config : config.url;
  }

  static getDataFromConfig(cache, config) {
    return cache.get(CacheService.createCacheKey(config, 'GET'));
  }

  static createCacheKey(config, method) {
    const url = typeof config === 'string' ? config : config.url;
    const cleanedConfig = {
      url,
      method
    };

    return JSON.stringify(cleanedConfig);
  }

  static set(cache, config, method, data) {
    const cacheKey = CacheService.createCacheKey(config, method);
    cache.set(cacheKey, data);
  }

  static addFromFindOne(cache, url, data) {
    if (data) {
      CacheService.onKeysOfUrl(cache, `${url}/${data.id}`, key => {
        cache.set(key, data);
      });
    }
  }

  static addFromFindAll(cache, url, data) {
    if (data) {
      CacheService.onKeysOfUrl(cache, url, key => {
        CacheService.addDataToKey(cache, key, data);
      });
    }
  }

  static update(cache, url, data) {
    CacheService.addFromFindOne(cache, url, data);

    CacheService.onKeysOfUrl(cache, url, key => {
      console.log(data, cache.get(key));
      cache.set(key, [...CacheService.updateItem(data, cache.get(key))]);
    });

    CacheService.onRelationToUpdate(
      cache,
      url,
      (key, { foreignKey, targetProperty }) => {
        const keyData = cache.get(key);

        if (keyData && Array.isArray(keyData)) {
          const index = keyData.findIndex(elem => elem.id === data[foreignKey]);

          if (keyData[index]) {
            const target = keyData[index][targetProperty];

            if (target) {
              if (Array.isArray(target)) {
                keyData[index][targetProperty] = CacheService.updateItem(
                  data,
                  target
                );
                cache.set(key, keyData);
              }
            }
          }
        }
      }
    );
  }

  static updateItem(item, data) {
    if (data && Array.isArray(data)) {
      return data.map(elem => {
        if (elem.id === item.id) {
          return {
            ...elem,
            ...item
          };
        }

        return elem;
      });
    }

    return [];
  }

  static getKeysOfUrl(cache, url) {
    return cache.keys().filter(key => {
      const keyObject = JSON.parse(key);

      if (keyObject.url === url && keyObject.method !== 'POST') {
        return key;
      }
    });
  }

  static getRelation(url) {
    return this.relationsToUpdate.find(relation => relation.url === url);
  }

  static addDataToKey(cache, key, data) {
    const keyObject = JSON.parse(key);
    let keyData = cache.get(key);

    if (!keyObject) {
      return;
    }

    if (!keyData || !Array.isArray(keyData)) {
      keyData = data;
    } else if (
      !keyObject.params?.per_page ||
      keyObject.params?.per_page > keyData.length
    ) {
      keyData.push(data);
    }

    cache.set(key, keyData);
  }

  static add(cache, url, data) {
    CacheService.onKeysOfUrl(cache, `${url}/${data.id}`, key => {
      cache.set(key);
    });

    CacheService.onKeysOfUrl(cache, url, key => {
      CacheService.addDataToKey(cache, key, data);
    });

    CacheService.onRelationToUpdate(
      cache,
      url,
      (key, { foreignKey, targetProperty }) => {
        const keyData = cache.get(key);

        if (keyData && Array.isArray(keyData)) {
          const index = keyData.findIndex(elem => elem.id === data[foreignKey]);

          if (keyData[index]) {
            const target = keyData[index][targetProperty];

            if (target) {
              if (Array.isArray(target)) {
                target.push(data);
                cache.set(key, target);
              }
            }
          }
        }
      }
    );
  }

  static delete(cache, url, id) {
    CacheService.onKeysOfUrl(cache, `${url}/${id}`, key => cache.delete(key));

    CacheService.onKeysOfUrl(cache, url, key => {
      const keyData = cache.get(key);

      if (keyData && Array.isArray(keyData)) {
        cache.set(key, [...keyData.filter(elem => elem.id !== id)]);
      }
    });

    // CacheService.onRelationToUpdate(
    //   cache,
    //   url,
    //   (key, { foreignKey, targetProperty }) => {
    //     const keyData = cache.get(key);

    //     if (keyData && Array.isArray(keyData)) {
    //       const index = keyData.findIndex(elem => elem.id === data[foreignKey]);

    //       if (keyData[index]) {
    //         const target = keyData[index][targetProperty];

    //         if (target) {
    //           if (Array.isArray(target)) {
    //             keyData[index][targetProperty] = target.filter(
    //               ta => ta.id !== id
    //             );
    //             cache.set(key, keyData);
    //           }
    //         }
    //       }
    //     }
    //   }
    // );
  }

  static onKeysOfUrl(cache, url, callback) {
    const keys = CacheService.getKeysOfUrl(cache, url);

    if (keys.length > 0) {
      keys.forEach(key => callback(key));
    }
  }

  static onRelationToUpdate(cache, url, callback) {
    const relation = CacheService.getRelation(url);

    if (!relation || !relation.relationsToUpdate) {
      return;
    }

    relation.relationsToUpdate.forEach(relationToUpdate => {
      const relationKeys = CacheService.getKeysOfUrl(
        cache,
        relationToUpdate.targetRelation
      );
      relationKeys?.forEach(relationKey =>
        callback(relationKey, relationToUpdate)
      );
    });
  }
}

export default CacheService;
